import React, { Component } from 'react';
import './GuessFlagApp.css';
import FlagGame from './FlagGame';

class GuessFlagApp extends Component {
  render() {
    return (
      <div className="GuessFlagApp">
        <header className="GuessFlagApp-header">
          <h1 className="GuessFlagApp-title">Guess the flag</h1>
        </header>
        <FlagGame />
      </div>
    );
  }
}

export default GuessFlagApp;



// WEBPACK FOOTER //
// ./src/GuessFlagApp.js